module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageNotFound":"Page not found"}}')
  delete Component.options._Ctor
}
